"use client";

import React, { useState } from "react";

type ReadMoreProps = {
  text: string;
  initialChars?: number;
};

export default function ReadMore({ text, initialChars = 300 }: ReadMoreProps) {
  const [expanded, setExpanded] = useState(false);

  const normalized = text.replace(/\r\n/g, "\n").replace(/<br\s*\/?>/gi, "\n");

  if (normalized.length <= initialChars) {
    // Render preserving line breaks
    return (
      <p className="text-gray-500 text-md md:text-base whitespace-pre-line">{normalized}</p>
    );
  }

  const preview = normalized.slice(0, initialChars).trim();

  return (
    <div>
      <p className="text-gray-500 text-md md:text-base whitespace-pre-line">
        {expanded ? normalized : `${preview}...`}
        <button
          type="button"
          aria-expanded={expanded}
          className="align-baseline text-[#007AFF] text-sm font-medium hover:underline outline-none focus:outline-none focus:ring-0"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      </p>
    </div>
  );
}
